import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const SettingSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M4.11432 13.8851C3.96189 12.968 3.96189 12.032 4.11432 11.1149C5.05078 11.137 5.89206 10.6883 6.21922 9.89885C6.54639 9.10856 6.26851 8.19591 5.59038 7.55093C6.13119 6.79403 6.7933 6.13165 7.54997 5.59051C8.1958 6.26863 9.10847 6.54651 9.89876 6.21934C10.6891 5.89218 11.1369 5.05006 11.1139 4.11446C12.0316 3.96185 12.9682 3.96185 13.8859 4.11446C13.863 5.05091 14.3117 5.89218 15.1011 6.21934C15.8914 6.54651 16.8041 6.26863 17.449 5.59051C18.2059 6.13132 18.8683 6.79342 19.4095 7.55008C18.7314 8.19591 18.4535 9.10856 18.7806 9.89885C19.1078 10.6891 19.9499 11.137 20.8855 11.114C21.0382 12.0317 21.0382 12.9683 20.8855 13.886C19.9491 13.863 19.1078 14.3117 18.7806 15.1011C18.4535 15.8914 18.7314 16.8041 19.4095 17.4491C18.8687 18.206 18.2066 18.8684 17.4499 19.4095C16.8041 18.7314 15.8914 18.4535 15.1011 18.7807C14.3108 19.1078 13.863 19.9499 13.8859 20.8855C12.9682 21.0382 12.0316 21.0382 11.1139 20.8855C11.1369 19.9491 10.6882 19.1078 9.89876 18.7807C9.10847 18.4535 8.1958 18.7314 7.55082 19.4095C6.79392 18.8687 6.13152 18.2066 5.59038 17.4499C6.26851 16.8041 6.54639 15.8914 6.21922 15.1011C5.89206 14.3109 5.04993 13.8622 4.11432 13.8851ZM12.5 15C13.1761 15 13.8245 14.7807 14.3026 14.3026C14.7807 13.8245 15.0493 13.1761 15.0493 12.5C15.0493 11.8239 14.7807 11.1755 14.3026 10.6974C13.8245 10.2193 13.1761 10 12.5 10C11.8239 10 11.1754 10.2193 10.6973 10.6974C10.2192 11.1755 9.95059 11.8239 9.95059 12.5C9.95059 13.1761 10.2192 13.8245 10.6973 14.3026C11.1754 14.7807 11.8239 15 12.5 15Z"
				fill="#4A4A4A"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.11432 13.8851C3.96189 12.968 3.96189 12.032 4.11432 11.1149C5.05078 11.137 5.89206 10.6883 6.21922 9.89885C6.54639 9.10856 6.26851 8.19591 5.59038 7.55093C6.13119 6.79403 6.7933 6.13165 7.54997 5.59051C8.1958 6.26863 9.10847 6.54651 9.89876 6.21934C10.6891 5.89218 11.1369 5.05006 11.1139 4.11446C11.5728 4.03815 12.0364 4 12.4999 4V10C11.1192 10 10 11.1193 10 12.5C10 13.8807 11.1192 15 12.4999 15V21C12.0364 21 11.5728 20.9618 11.1139 20.8855C11.1369 19.9491 10.6882 19.1078 9.89876 18.7807C9.10847 18.4535 8.1958 18.7314 7.55082 19.4095C6.79391 18.8687 6.13152 18.2066 5.59038 17.4499C6.26851 16.8041 6.54639 15.8914 6.21922 15.1011C5.89206 14.3109 5.04993 13.8622 4.11432 13.8851Z"
				fill="url(#paint0_linear_13382_131572)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_13382_131572"
					x1="3.57501"
					y1="21.9444"
					x2="3.57501"
					y2="3.05556"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#568DFE" />
					<stop offset="1" stopColor="#E4EDFC" />
				</linearGradient>
			</defs>
		</svg>
	)
})
